import React from "react";

type SessionProps = {
  username: string;
  email: string;
  firstName: string;
  lastName: string;
  name: string;
  clientId: string;
  corpdb: string;
  corpuser: "Yes" | "No";
  currentReport: string;
  defaultReport: string;
  defaultZoom: number;
  department: string;
  dms: string;
  dmsnum: string;
  groupnum: number;
  ftusertype: string;
  ftonly: "Yes" | "No";
  FTUser: "Yes" | "No";
  TitleOpsUser: "Yes" | "No";
  DocuOpsUser: "Yes" | "No";
  MarketShareUser: "Yes" | "No";
  ExpenseGuideUser: "Yes" | "No";
  phone: string;
  passreset: "Yes" | "No";
  servername: string;
  storename: string;
  useraccess: string[];
  useraccesscorp: string[];
  zMake: string;
  zRegion: string;
  uid: number;
  readOnly: boolean;
};

export const SessionContext = React.createContext<Partial<SessionProps>>({});
